import * as React from 'react'
import { Field, useFormState } from 'react-final-form'

import * as Styled from '../Form.styles'

const Checkbox = ({
  name,
  options,
  label = '',
  validations = null,
  onChange = () => {},
  formRef = '',
}) => {
  const formState = useFormState()

  return (
    <Styled.OptionGroup gridArea={name}>
      <Styled.Label className="label checkbox-label">{label}</Styled.Label>
      <div className={`options_${name}`}>
        {options.map((option, index) => (
          <Field
            name={name}
            key={option.name}
            validate={validations}
            type="checkbox"
            value={option.value}
          >
            {({ input, meta }) => {
              const checkboxOnChange = (e) => {
                input.onChange(e)
                Promise.resolve(
                  onChange({
                    formRef,
                    values: { ...formState.values },
                    consentGiven: e.currentTarget.checked,
                  })
                )
              }

              return (
                <Styled.OptionLabel gridArea={option.name}>
                  <Styled.Input
                    {...input}
                    aria-invalid={Boolean(meta.touched && meta.error)}
                    onChange={checkboxOnChange}
                  />
                  <Styled.LabelText>{option.label}</Styled.LabelText>
                  {/* An error message gets placed on every checkbox in the group but we only
                want to show the error after the last input. */}
                  {meta.error &&
                    meta.touched &&
                    index === options.length - 1 && (
                      <Styled.ErrorText className="error-text">
                        {meta.error}
                      </Styled.ErrorText>
                    )}
                </Styled.OptionLabel>
              )
            }}
          </Field>
        ))}
      </div>
    </Styled.OptionGroup>
  )
}

export default Checkbox
